import { OTAFileCategories, OTAFileV2 } from '../interfaces';
import { useOTAFilesQuery } from '../queries';

export const useOTAFiles = (): OTAFileV2[] => {
  const query = useOTAFilesQuery();
  const allAvailableFiles = query.data || [];

  return allAvailableFiles;
};

export const useFirmwares = () => {
  const otaFiles = useOTAFiles();
  return otaFiles.filter((f) => f.category === OTAFileCategories.UbloxFirmware);
};

export const useUbloxConfigs = () => {
  const otaFiles = useOTAFiles();
  return otaFiles.filter((f) => f.category === OTAFileCategories.UbloxConfigs);
};

export const useSTMFirmwares = () => {
  const otaFiles = useOTAFiles();
  return otaFiles.filter((f) => f.category === OTAFileCategories.STMFirmware);
};
